import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=2e50f964&scoped=true"
import script from "./vertical.vue?vue&type=script&lang=ts"
export * from "./vertical.vue?vue&type=script&lang=ts"
import style0 from "./vertical.vue?vue&type=style&index=0&id=2e50f964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50f964",
  null
  
)

export default component.exports